<template>
  <div v-if="pivotData.length > 0" style="padding: 2rem;">
    <h1>{{title}}</h1>

    <p>
      <template v-if="analysisSettings.analysisType == 'gtin_list'">
        GTIN: {{analysisSettings.gtins.map(i => i.gtin).join(', ')}}
      </template>
      <template v-if="analysisSettings.analysisType == 'molecule'">
        Molecule: {{analysisSettings.molecules.map(i => i.molecule).join(', ')}}
      </template>
    </p>

    <vue-pivottable-ui
        :data="pivotData"
        aggregatorName='Sum'
        rendererName='Table Heatmap'
        :rows="rows"
        :cols="cols"
        :vals="vals"
    >
    </vue-pivottable-ui>
  </div>
</template>

<script>
import {VuePivottable, VuePivottableUi} from 'vue-pivottable'
import 'vue-pivottable/dist/vue-pivottable.css'
import axios from 'axios'

export default {
  layout: 'plain',
  data: () => ({
    title: '',
    pivotData: [],
    analysisSettings: {},
    aggregatorName: 'Sum',
    rendererName: 'Table Heatmap',
    rows: ['Uploader'],
    cols: [],
    vals: ['Turnover Potential'],
    disabledFromDragDrop: [],
    hiddenFromDragDrop: []
  }),
  mounted() {
    axios.get('/api/sandoz/assortment_analysis/' + this.$route.params.direct_link + '/pivot-standalone').then((response) => {
      this.title = response.data.title
      this.analysisSettings = response.data.analysis_settings
      this.pivotData = response.data.data
    })
  },
  methods: {
    toggle: function (todo) {
      todo.done = !todo.done
    }
  },
  components: {
    VuePivottable,
    VuePivottableUi
  }
}
</script>
